import { Button, Styles } from "@/shared/coralreef";
import { useTranslation } from "react-i18next";
import { createInstance } from "i18next";
import { useMemo } from "react";
import { en } from "@/exported/i18n/en";
import { es } from "@/exported/i18n/es";
import { no } from "@/exported/i18n/no";

export function useBootTranslation() {
  const bootI18n = useMemo(() => {
    let language = "en";
    try {
      language = localStorage.getItem("observe.shell.lang") || "en";
    } catch {}
    const instance = createInstance();
    void instance.init({
      resources: { en, es, no },
      lng: language,
      fallbackLng: "en",
      defaultNS: "ns1",
      keySeparator: false,
      initImmediate: false,
    });
    return instance;
  }, []);
  return useTranslation("ns1", { i18n: bootI18n, useSuspense: false });
}

export function BootFailed({ message }: { message: string }) {
  const { t } = useBootTranslation();
  return (
    <div
      data-testid="boot-failed"
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        padding: 24,
        textAlign: "center",
        background: Styles.Colours.darkestBlue,
        color: Styles.Colours.textLight,
      }}
    >
      <div style={{ fontSize: "1.25rem" }}>{t("The app could not start")}</div>
      <div data-testid="boot-failed-message" style={{ opacity: 0.8 }}>
        {message}
      </div>
      <Button
        type="button"
        content={t("Reload")}
        appearance="hollow"
        onClick={() => window.location.reload()}
      />
    </div>
  );
}
